<template>
  <div>
    <div class="title-wrap">
      <span class="title">政策月历</span>
    </div>
    <div class="wrap">
      <div ref="calendar" class="calendar">
        <div class="header">
          <img src="@/assets/images/calendar.png" alt="" />
          <div class="year">
            <!-- <i class="el-icon-arrow-left pointer" /> -->
            <span>{{ year }}</span>
            <!-- <i class="el-icon-arrow-right pointer" /> -->
          </div>
        </div>
        <div class="month">
          <div v-for="item in monthList" :key="item.month" class="month-item pointer"
            :class="{ current: item.month == selectMonth }" @click="handleMonth(item.month)">
            <p class="month-title">{{ item.month + '月' }}</p>
            <div class="month-content">
              <div v-if="item.expired" class="notice expired">
                <span>申报已截止</span><span>{{ item.expired }}</span>
              </div>
              <div v-if="item.progress" class="notice progress">
                <span>申报进行中</span><span>{{ item.progress }}</span>
              </div>
              <div v-if="item.wait" class="notice wait">
                <span>申报未开始</span><span>{{ item.wait }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="policy">
        <div ref="header" class="tabs-wrap" style="margin-bottom: 15px">
          <span class="title">状态：</span>
          <ul class="tabs">
            <li v-for="(item, index) in tabs" :key="item" class="tabs-item pointer"
              :class="{ active: isActive === index }" @click="isActive = index">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
        <div v-show="!policyList || policyList.length <= 0" class="title-wrap">
          <img src="../../../../assets/images/缺省页.png" width="80%" />
        </div>
        <ul v-show="policyList.length > 0" ref="policy" class="content" style="max-height: 0">
          <li v-for="item in policyList" :key="item.zzmhPolicyVo.id" class="pointer content-wrap"
            @click="handleGoPage(item.zzmhPolicyVo.id)">
            <policy-item :status="status[item.timeType - 1]"
              :type="item.timeType === 1 ? 'warning' : item.timeType === 2 ? 'primary' : 'info'">
              <template slot="tag">
                {{ item.zzmhPolicyVo.originLevel }}
              </template>
              <template slot="title">
                {{ item.zzmhPolicyVo.title }}
              </template>
              <template slot="content">
                <div class="item">
                  <el-tooltip class="item" effect="light" placement="top">
                    <!-- <el-button>上边</el-button> -->
                    <template slot="content">
                      <p class="tooltip" style="max-width: 500px">
                        申报时间：
                        {{
                          item.zzmhPolicyVo.title === '青年人才租房补贴'
                          ? '每月21日～月底'
                          : item.zzmhPolicyVo.applyTimeType !== 1
                            ? item.zzmhPolicyVo.applyTm
                            : '常态受理'
                        }}
                        {{ item.zzmhPolicyVo.applyTimeType == 3 ? '(以具体通知为准)' : '' }}
                      </p>
                    </template>
                    <p class="hide">
                      申报时间：
                      {{
                        item.zzmhPolicyVo.title === '青年人才租房补贴'
                        ? '每月21日～月底'
                        : item.zzmhPolicyVo.applyTimeType !== 1
                          ? item.zzmhPolicyVo.applyTm
                          : '常态受理'
                      }}
                      {{ item.zzmhPolicyVo.applyTimeType == 3 ? '(以具体通知为准)' : '' }}
                    </p>
                  </el-tooltip>
                </div>
              </template>
            </policy-item>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import PolicyItem from '@/components/PolicyItem'

export default {
  name: 'PolicyMonth',
  components: { PolicyItem },
  data() {
    return {
      dataList: [],
      year: new Date().getFullYear(),
      status: ['申报未开始', '申报进行中', '申报已截止'],
      selectMonth: moment().month() + 1,
      isActive: 0,
      tabs: ['全部', '申报未开始', '申报进行中', '申报已截止'],
    }
  },
  computed: {
    monthList() {
      let list = []
      Object.keys(this.dataList).forEach((key) => {
        let monthObj = { month: key, wait: 0, progress: 0, expired: 0 }

        Object.keys(this.dataList[key]).forEach((keySub) => {
          switch (this.dataList[key][keySub].timeType) {
            case 1:
              monthObj.wait++
              break
            case 2:
              monthObj.progress++
              break
            case 3:
              monthObj.expired++
              break
            default:
              break
          }
        })
        list.push(monthObj)
      })
      this.resize()
      return list
    },
    policyList() {
      let currentMonth = this.dataList[this.selectMonth]
      if (currentMonth) {
        if (this.isActive > 0) {
          let list = []
          for (let v of currentMonth) {
            if (v.timeType === this.isActive) {
              list.push(v)
            }
          }
          currentMonth = list
        }
      } else {
        currentMonth = []
      }
      return currentMonth
    },
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
    this.getMonthPolicy()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    resize() {
      this.$nextTick(() => {
        let calendarHeight = this.$refs.calendar.offsetHeight
        let headerHeight = this.$refs.header.offsetHeight
        this.$refs.policy.style.maxHeight = calendarHeight - headerHeight - 15 + 'px'
      })
    },
    getMonthPolicy() {
      this.$http({ method: 'GET', url: '/zzmh/api/policy/yearData' }).then((res) => {
        if (res.code === 0) {
          let list = res.data
          this.dataList = list
        }
      })
    },
    handleMonth(month) {
      this.selectMonth = month
    },
    handleGoPage(id) {
      this.$router.push('/policy-detail/' + id)
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
